module.exports = __webpack_public_path__ + "images/3b15e56520e10d7082ec28982215666e.jpg";